module.exports = __webpack_public_path__ + "static/img/3areaB_19.e8ab8ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_19.png
// module id = 1161
// module chunks = 1